export const TESTS_ROUTE = '/tests'